import {Injectable} from '@angular/core';
import {Hub} from 'aws-amplify/utils';
import {Router} from "@angular/router";
import {BehaviorSubject, map} from "rxjs";
import {fetchAuthSession, getCurrentUser} from 'aws-amplify/auth';
import {signOut} from 'aws-amplify/auth';
import {UserService} from "./user.service";
import {SpotfightUser} from "../core/models/models";


export interface AuthState {
  isLoggedIn: boolean;
  id: string | null;
  authToken: string;
}

const initialAuthState = {
  isLoggedIn: false,
  id: null,
  authToken: "",
};


@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  private readonly _authState = new BehaviorSubject<AuthState>(
    initialAuthState
  );

  private readonly _user = new BehaviorSubject<SpotfightUser | null>(null);

  readonly auth$ = this._authState.asObservable();
  readonly user$ = this._user.asObservable();

  readonly isLoggedIn$ = this.auth$.pipe(map(state => state.isLoggedIn));

  constructor(private router: Router,
              private userService: UserService) {
    this.refreshUserState();

    Hub.listen('auth', ({payload}) => {
      switch (payload.event) {
        case 'signedIn':
          this.refreshUserState();
          console.log('user have been signedIn successfully.');
          break;
        case 'signedOut':
          this._authState.next(initialAuthState);
          console.log('user have been signedOut successfully.');
          this.router.navigate(['']);
          break;
      }
    });
  }

  public async refreshUserState() {
    console.log("Refresh user state");
    try {
      const {username, userId, signInDetails} = await getCurrentUser();
      const authToken = (await fetchAuthSession()).tokens?.accessToken?.toString() ?? "";
      this.setUser(userId, authToken)
    } catch (err) {
      console.log("User not logged in!")
      console.log(err);
      this._authState.next(initialAuthState);
      this.router.navigate(['']);
    }
  }

  private setUser(userId: string, authToken: string) {
    if (!userId) {
      return;
    }
    this._authState.next({isLoggedIn: true, id: userId, authToken: authToken});
    this.userService.fetchCurrentUser()
      .then((user) => {
        this._user.next(user);
      })
      .catch((err) => console.log(err));
  }

  getCurrentLoginStatus(): boolean {
    return this.getAuthStateSnapshot().isLoggedIn;
  }

  async signOut() {
    try {
      await signOut();
    } catch (error) {
      console.log('error signing out: ', error);
    }
  }

  getAuthStateSnapshot(): AuthState {
    return this._authState.value;
  }

  getUser(): SpotfightUser | null {
    return this._user.value;
  }
}
